import { useTranslation } from "react-i18next";
import { rgbToCss } from "utils/rgbToCss";
import { DOOR_RGB, WALL_RGB, WINDOW_RGB } from "../utils/floorPlanLayout";
import type { WallCounts } from "../hooks/useFloorPlanLayoutView";
import type { WallsSummaryProps } from "./types";

// In the order they are listed; the swatches match the colours on the plan.
const WALL_KINDS: { kind: keyof WallCounts; rgb: [number, number, number] }[] =
  [
    { kind: "walls", rgb: WALL_RGB },
    { kind: "doors", rgb: DOOR_RGB },
    { kind: "windows", rgb: WINDOW_RGB },
  ];

// Hidden for now; flip to true to show the counts again
const ARE_WALL_COUNTS_SHOWN = false;

export const WallsSummary = ({ counts }: WallsSummaryProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-3">
      <p className="text-xs text-gray-500">
        {t("smartSurveyor.walls.legendHint")}
      </p>
      <div className="grid grid-cols-3 gap-2">
        {WALL_KINDS.map(({ kind, rgb }) => (
          <div key={kind} className="rounded-lg border border-gray-200 p-3">
            {ARE_WALL_COUNTS_SHOWN && (
              <div className="text-xl font-semibold tabular-nums text-gray-900">
                {counts[kind]}
              </div>
            )}
            <div className="flex items-center gap-1.5 text-xs text-gray-500">
              <span
                className="h-2.5 w-2.5 shrink-0 rounded-sm opacity-70"
                style={{ backgroundColor: rgbToCss(rgb) }}
              />
              {t(`smartSurveyor.walls.${kind}`)}
            </div>
          </div>
        ))}
      </div>
      <p className="rounded-lg border border-dashed border-gray-300 px-4 py-3 text-sm text-gray-500">
        {t("smartSurveyor.walls.viewOnlyNote")}
      </p>
    </div>
  );
};
